module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_gk_zdhkz@2x.ac683605.png";